import { number, ObjectSchema, object, string } from 'yup';

export const DEFAULT_ERROR_MESSAGES = {
  SOMETHING_WENT_WRONG: 'common.errors.somethingWentWrong',
  KEYCLOAK_INIT: 'common.errors.keycloakInit',
  KEYCLOAK_GET_TOKEN: 'common.errors.keycloakGetToken',
};

export enum ErrorCodeTypes {
  FULL_PAGE,
  NOTIFICATION,
}

export const ERRORS = {
  SOMETHING_WENT_WRONG: (message?: string) =>
    new Error(
      JSON.stringify({
        code: ErrorCodeTypes.FULL_PAGE,
        message,
        defaultMessage: DEFAULT_ERROR_MESSAGES.SOMETHING_WENT_WRONG,
      }),
    ),
  REGULAR: (message?: string) =>
    new Error(
      JSON.stringify({
        code: ErrorCodeTypes.FULL_PAGE,
        message,
      }),
    ),
  KEYCLOAK_INIT: (message?: string) =>
    new Error(
      JSON.stringify({
        code: ErrorCodeTypes.FULL_PAGE,
        message,
        defaultMessage: DEFAULT_ERROR_MESSAGES.KEYCLOAK_INIT,
      }),
    ),
  KEYCLOAK_GET_TOKEN: (message?: string) =>
    new Error(
      JSON.stringify({
        code: ErrorCodeTypes.NOTIFICATION,
        message,
        defaultMessage: DEFAULT_ERROR_MESSAGES.KEYCLOAK_GET_TOKEN,
      }),
    ),
};

export type ApplicationError = {
  code: ErrorCodeTypes;
  message?: string;
  defaultMessage?: string;
};

const applicationErrorSchema: ObjectSchema<ApplicationError> = object({
  code: number()
    .oneOf(Object.values(ErrorCodeTypes) as number[])
    .required(),
  message: string(),
  defaultMessage: string(),
});

export const parseError = (error: Error): ApplicationError => {
  const applicationError = JSON.parse(error.message);

  if (!applicationErrorSchema.isType(applicationError)) {
    throw new Error(`Application error is in invalid format: ${error.message}`);
  }

  return applicationError;
};
